var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "60%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "3" } },
                      [
                        _c("sys-select-offer-item-protocol-status", {
                          attrs: {
                            model: _vm.innerModel.offer_item_protocol_status_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.offer_item_protocol_status_id,
                            label: "Status*",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.innerModel,
                                "offer_item_protocol_status_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("s-text-field", {
                          attrs: { disabled: "", label: "Descrição" },
                          model: {
                            value: _vm.innerModel.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.innerModel, "description", $$v)
                            },
                            expression: "innerModel.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("s-text-field", {
                          attrs: { disabled: "", label: "Oferta" },
                          model: {
                            value: _vm.innerModel.offer,
                            callback: function ($$v) {
                              _vm.$set(_vm.innerModel, "offer", $$v)
                            },
                            expression: "innerModel.offer",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("v-textarea", {
                          attrs: {
                            error: !!_vm.errors.note,
                            "error-messages": _vm.errors.note,
                            label: "Observação do Aprovador",
                            counter: 255,
                            rows: "2",
                            rules: [
                              (v) =>
                                !v ||
                                v.length <= 255 ||
                                "Máximo de 255 caracteres atingido",
                            ],
                            outlined: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.innerModel.note,
                            callback: function ($$v) {
                              _vm.$set(_vm.innerModel, "note", $$v)
                            },
                            expression: "innerModel.note",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }